import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const UserValidation = () => {
  const location = useLocation();
  const { isAuthenticated, refreshSession } = useAuth();

  useEffect(() => {
    if (isAuthenticated && location.pathname !== '/login') {
      refreshSession().catch(() => {
        // 401 handled by interceptor
      });
    }
  }, [location.pathname, isAuthenticated, refreshSession]);

  return null;
};

export default UserValidation;
